module.exports = __webpack_public_path__ + "static/media/app-store-badge.c03e849a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-store-badge.svg
// module id = 1243
// module chunks = 27